import React, { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav, Button, NavDropdown, Form , Col, Row, Offcanvas} from 'react-bootstrap';
import logo from '../images/logo.svg'
import search from '../images/Search.png'

import Notificationbell from '../images/Notificationbell.png'


const AppNavbar = () => {
  const navigate = useNavigate()
  return (
    
        
       
    <Navbar expand="lg" variant="light" bg="white" className='px-3 px-sm-5 align-items-center'>
   
      <Navbar.Brand className=''>
        <Link to='/'>
        <img src={logo} alt="Tripz-logo" style={{width:'100px', marginBottom:'15px'}} />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarSupportedContent" />
      <Navbar.Collapse id="navbarSupportedContent" >
        <Nav className="mx-auto gap-2 gap-md-4 " style={{fontWeight:'600', color:'#292D32'}}>
        <Nav.Link onClick={() => navigate('/')}>Home</Nav.Link>
        <Nav.Link onClick={() => navigate('/about')}>About Us</Nav.Link>
          <Nav.Link onClick={() => navigate('/booking')}>Bookings</Nav.Link>
          
          <Nav.Link onClick={() => navigate('/explore')}>Explore</Nav.Link>
          
        </Nav>
        <Nav className="gap-3 " style={{fontWeight:'600', color:'#292D32'}}>
          
          <NavDropdown title="NGN" id="navbar-dropdown" className='mt-3 '>
            <NavDropdown.Item href="#action1">Naira</NavDropdown.Item>
            <NavDropdown.Item href="#action2">USD</NavDropdown.Item>
            <NavDropdown.Item href="#action3">Pounds</NavDropdown.Item>
            <NavDropdown.Item href="#action4">Euro</NavDropdown.Item>

          </NavDropdown>
          <Nav.Link onClick={() => navigate('/signup')}>
            
            <Button style={{height: '48px',
    width: '241px',
    
    borderRadius: '8px',
    
    backgroundColor: '#008080'}}>
             Sign Up
            </Button>
            
          </Nav.Link>    
        </Nav>
      </Navbar.Collapse>
    
  </Navbar>
 
  );
};

export default AppNavbar;
